import * as React from 'react';
import { LoginButton } from './LoginButton';

export interface LoginProps {
  initiateAuthRequest(provider: string): void;
  initiatePopupCloseRequest(): void;
}

export class Login extends React.Component<LoginProps, {}> {


  render() {
    const { initiateAuthRequest, initiatePopupCloseRequest } = this.props;
    return (
      <div className="login-section">
        <div className="login-item">
          <LoginButton
            provider="Asurion"
            initiateAuthRequest={initiateAuthRequest}
            initiatePopupCloseRequest={initiatePopupCloseRequest}
          />
        </div>
        <div className="login-item">
          <LoginButton
            provider="Google"
            initiateAuthRequest={initiateAuthRequest}
            initiatePopupCloseRequest={initiatePopupCloseRequest}
          />
        </div>

      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Login/Login.tsx